/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { filter, tap } from 'rxjs';
import { InputModule } from '@sag-ui';

@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    imports: [CommonModule, InputModule, FormsModule, ReactiveFormsModule],
    standalone: true
})
export class NumberInputComponent implements OnInit, OnChanges {
    @Input() value: number;
    @Input() max = 100;
    @Input() readonly = false;
    @Input() ariaLabel = 'Affected Quantity';
    @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

    public input = new FormControl(0);

    ngOnInit(): void {
        this.initInputChanges();
        this.initValue();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.initValue();
        }
    }

    public increment(): void {
        this.input?.setValue(Math.min(this.max, this.input.value! + 1));
    }

    public decrement(): void {
        this.input?.setValue(Math.max(0, this.input.value! - 1));
    }

    public handleChange(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        this.input.setValue(Math.min(this.max, Math.max(0, parseInt(value, 10))));
    }

    public preventNonNumericInput(event: KeyboardEvent): void {
        if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
            event.preventDefault();
        }
    }

    private initInputChanges(): void {
        this.input?.valueChanges
            .pipe(
                filter(value => value !== null && value !== undefined && !isNaN(value as number)),
                tap(value => {
                    this.valueChange.emit(parseInt(value!.toString(), 10));
                })
            )
            .subscribe();
    }

    private initValue(): void {
        this.input.setValue(this.value);
        this.readonly && this.input.disable();
    }
}
